// Each daily source turns over at 12:00 UTC on the day its data usually lands, so the newest day
// shown is complete by 8am Eastern: Vendor Central lands at ~09:17 UTC on the third day, Seller
// Central traffic at ~10:30 on the second, ads at ~07:00 the next day, and seller compliance is
// refreshed by ~10:50. Raider's tools use the same delays, so dashboards and agents show the same
// days. The home page keeps whole days (ExecutiveHomePage/const.ts).
export const SELLER_CENTRAL_LAG_HOURS = 60
export const VENDOR_CENTRAL_LAG_HOURS = 84
export const SELLER_COMPLIANCE_LAG_HOURS = 84
export const ADS_LAG_HOURS = 36
